import { COIN_TICKER } from './Crypto';

/* eslint-disable @typescript-eslint/naming-convention */
export interface ICharge {
  id: string;
  user_id: string;
  price: IChargePrice;
  metadata: { items: IChargeItem[]; logo_url: string; accent_color: string; client: IClient };
  pricing: IChargePrice[];
  status: CHARGE_STATUS;
  timeline: { time: string; status: CHARGE_STATUS }[];
  deposit_address: {
    bsc: string;
    eth: string;
    terra: string;
  };
  payments: {
    chain: string;
    coin: COIN_TICKER;
    from: string;
    hash: string;
    status: string;
    to: string;
    value: {
      wei: string;
      human: string;
    };
  }[];
  ttl: number;
  redirect_url: string;
  cancel_url: string;
  creation_time: string;
  hosted_url: string;
  fee?: string;
}

export interface IClient {
  address_1: string;
  address_2: string;
  city: string;
  company: string;
  country: string;
  email: string;
  first_name: string;
  last_name: string;
  phone: string;
  postcode: string;
  state: string;
}

export interface IChargePrice {
  amount: string;
  currency: string;
}

export interface IChargeItem {
  id?: string;
  name: string;
  desc: string;
  price: string;
  quantity?: number;
  image_url?: string;
}

export interface IChargeStats {
  lastPaymentAmount: number;
  lastPaymentCurrency: string;
  paymentsInTimeframe: number;
  paymentsInTimeframeSum: number;
  statsInDivision: number[];
  timeFrame: string;
  timeFrameDivisions: number;
  timeFrameDivisionsType: string;
}

export interface IChargesResponse {
  charges: ICharge[];
  pageCount: number;
  pageSize: number;
  totalCount: number;
  periodicity?: string;
}

export interface ICommerceConfig {
  apiKey?: string;
  webhookSecret?: string;
  displayName?: string;
  accentColor?: string;
  logoUrl?: string;
  logoImg?: File;
  fee?: number;
  integrations?: {
    tiendaNube: { storeId?: string; paymentProviderId?: string; token?: string };
    vtex: { appKey?: string; appToken?: string };
  };
  rules?: {
    autoSellToArs?: boolean;
  };
}
export interface ICommerceLandingForm {
  name: string;
  email: string;
  phoneNumber: string;
  companyName: string;
  url: string;
  type: string;
  integration?: string; // si no mandas nada pone 'N/A' automáticamente por back
  paymentGateway?: string; // si no mandas nada pone 'N/A' automáticamente por back
  billingType: string;
}

export interface ICommerceUserForm {
  name?: string;
  email?: string;
  phoneNumber?: string;
  companyName?: string;
  url?: string;
  type?: string;
  integration?: string;
  paymentGateway?: string;
  billingType?: string;
}

export interface IRules {
  type: string;
}

export enum COMMERCE_FORM_STEPS {
  TYPE = 'type',
  INTEGRATION = 'integration',
  FORM = 'form',
  BILLINGTYPE = 'billingType',
  THANKS = 'thanks',
}

export enum COMMERCE_FORM_OPTIONS {
  ECOMMERCE = 'ECOMMERCE',
  SHOP = 'SHOP',
  TIENDANUBE = 'TIENDANUBE',
  WOOCOMMERCE = 'WOOCOMMERCE',
  EMPRETIENDA = 'EMPRETIENDA',
  PRESTASHOP = 'PRESTASHOP',
  MAGENTO = 'MAGENTO',
  VTEX = 'VTEX',
  WIX = 'WIX',
  ECWID = 'ECWID',
  INDIVIDUAL = 'INDIVIDUAL',
  COMPANY = 'COMPANY',
  OTHERS = 'OTHERS',
}

export interface ICommerceLandingForm {
  name: string;
  email: string;
  phoneNumber: string;
  companyName: string;
  url: string;
  type: string;
  integration?: string; // si no mandas nada pone 'N/A' automáticamente por back
  paymentGateway?: string; // si no mandas nada pone 'N/A' automáticamente por back
  billingType: string;
}

export enum CHARGE_STATUS {
  NEW = 'NEW',
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  UNDERPAID = 'UNDERPAID',
  OVERPAID = 'OVERPAID',
  MULTIPLE = 'MULTIPLE',
  DELAYED = 'DELAYED',
  UNRESOLVED = 'UNRESOLVED',
  RESOLVED = 'RESOLVED',
  CANCELLED = 'CANCELLED',
  RISKY = 'RISKY',
  REFUNDING = 'REFUNDING',
  REFUNDED = 'REFUNDED',
  REFUND_ERRORED = 'REFUND_ERRORED',
}

export enum CHARGE_STATUS_TEXT {
  NEW = 'Nuevo',
  PENDING = 'Pendiente',
  COMPLETED = 'Completado',
  EXPIRED = 'Expirado',
  UNDERPAID = 'Pagado de menos',
  OVERPAID = 'Pagado de más',
  MULTIPLE = 'Múltiple',
  DELAYED = 'Demorado',
  UNRESOLVED = 'Irresoluto',
  RESOLVED = 'Resuelto',
  CANCELLED = 'Cancelado',
  RISKY = 'Evaluando pago',
  REFUNDING = 'Reembolsando',
  REFUNDED = 'Reembolsado',
  REFUND_ERRORED = 'Reembolso fallido',
}
